<template>
  <div class="car-info">
    <a-descriptions bordered v-viewer>
      <a-descriptions-item label="车辆牌照">{{info.car_number}}</a-descriptions-item>
      <a-descriptions-item label="车主姓名">{{info.car_owner_name}}</a-descriptions-item>
      <a-descriptions-item label="车主电话">{{info.mobile}}</a-descriptions-item>
      <a-descriptions-item label="状态">{{carStatusText(info.state)}}</a-descriptions-item>
      <a-descriptions-item label="车辆行驶证">
        <dy-image :src="info.drive_image"></dy-image>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions v-if="isReview">
      <a-descriptions-item>
        <a-space>
          <a-button type="primary" @click="review">审核通过</a-button>
          <a-button type="primary" @click="overrule">驳回</a-button>
        </a-space>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
  import {
    carStatusText
  } from '@/io/dict.js';
  import CarService from '@/io/car.js';

  export default {
    name: 'CarInfo',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      isReview: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        carStatusText,
        info: {}
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initPage();
        },
        immediate: true
      }
    },
    methods: {
      initPage() {
        if (this.id) {
          CarService.info(this.id).then(res => {
            this.info = res;
          }).catch(err => {});
        }
      },
      review() {
        let self = this;
        this.$confirm({
          title: `该车牌号码为${this.info.car_number}`,
          content: '确认审核通过？',
          onOk() {
            CarService.review(self.id).then(() => {
              self.$emit('confirm');
            });
          }
        });
      },
      overrule() {
        CarService.overrule(this.id).then(() => {
          this.$emit('confirm');
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>